import { Box, Typography, Button } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const theme = createTheme({
  typography: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
  },
});

const colors = {
  // navy: "#0d233b",
  grey: "#404041",
  blue: "#0b5299",
  hoverBlue: "#093e72",
  gold: "#be9337",
  orange: "#d06c38",
};

export default function AlumniHome() {
  const navigate = useNavigate();
  return (
    <ThemeProvider theme={theme}>
      <style>
        {`@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,200;1,400;1,600;1,700&display=swap');`}
      </style>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          minHeight: "100vh",
          fontFamily: "'Plus Jakarta Sans', sans-serif",
        }}
      >
        {/* LEFT IMAGE */}

        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            backgroundImage: "url('/images/alumni/1.jpg')",
            height: { xs: "300px", md: "auto" },
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />

        {/* RIGHT CONTENT */}

        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            flex: 1,
            background: colors.grey,
            color: "white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            px: { xs: 3, md: 8 },
            py: { xs: 5, md: 0 },
            fontFamily: "'Plus Jakarta Sans', sans-serif",
          }}
        >
          {/* <Typography
            sx={{
              letterSpacing: 2,
              fontSize: 12,
              opacity: 0.6,
              fontWeight: 600,
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              mb: 2,
            }}
          >
            ALUMNI PORTAL
          </Typography> */}

          <Box
            sx={{
              width: { xs: "360px", md: "440px" },
              maxWidth: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <Box
              component="img"
              src="/site-logo.svg"
              alt="Aditya University"
              sx={{
                width: "100%",
                height: "auto",
                mb: 0,
              }}
            />

            <Typography
              sx={{
                fontSize: { xs: "18px", md: "24px" },
                fontWeight: 600,
                letterSpacing: 2,
                lineHeight: 1.2,
                color: "white",
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                mt: "-6px",
                textAlign: "right",
                mr: { xs: "-15px", md: "-40px" },
              }}
            >
              Alumni Network
            </Typography>
          </Box>

          <Typography
            sx={{
              mt: 3,
              // opacity: 0.85,
              maxWidth: { xs: "100%", md: 500 },
              lineHeight: 1.6,
              fontSize: { xs: "13px", md: "14px" },
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 200,
            }}
          >
            Your journey after university matters to us. <br />
            Help us keep our alumni records up to date by sharing your details.
          </Typography>

          <Button
            variant="contained"
            disableElevation
            onClick={() => navigate("/alumni/register")}
            sx={{
              mt: 4,
              width: "fit-content",
              backgroundColor: colors.blue,
              color: "#ffffff",
              textTransform: "none",
              borderRadius: 0,
              boxShadow: "none",
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 400,
              px: 3,
              py: 1,
              position: "relative",
              overflow: "hidden",
              zIndex: 1,
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: colors.hoverBlue,
                zIndex: 1,
                transform: "scaleX(0)",
                transformOrigin: "left center",
                transition: "transform 0.5s ease",
              },
              "&:hover": {
                backgroundColor: colors.blue,
                boxShadow: "none",
                "&::before": {
                  transform: "scaleX(1)",
                },
              },
              "& .btn-text": {
                position: "relative",
                zIndex: 2,
                color: "#ffffff",
              },
            }}
          >
            <Box
              component="span"
              className="btn-text"
              sx={{
                position: "relative",
                zIndex: 2,
                color: "#ffffff",
                display: "inline-block",
              }}
            >
              Join the Network
            </Box>
          </Button>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
